<ng-container *ngIf="visible">
  <div class="confirmation-dialog-backdrop" [style.z-index]="zindex ? zindex - 1 : ''"></div>
  <div class="confirmation-dialog-container" [style.z-index]="zindex ? zindex + 1 : ''">
    <div class="confirmation-dialog-header" [ngStyle]="{ 'background-color': propertyHistory ? '#fff' : '#229276' }">
      <h2 class="confirmation-dialog-title {{ propertyHistory ? '_fw-600' : '' }}" [ngStyle]="{ color: propertyHistory ? '#1a2f45' : '#fff' }">
        {{ title }}
      </h2>
      <button
        type="button"
        class="btn-close-confirmation-dialog close pull-right {{ propertyHistory ? 'cross-opacity' : '' }}"
        aria-label="Close"
        (click)="close()">
        <span class="font-weight-bold" [ngStyle]="{ color: propertyHistory ? '#1a2f45' : '#fff' }">
          <ng-continer *ngIf="propertyHistory; else elseClose">
            <img [src]="images?.close_square" alt="close" width="28px" />
          </ng-continer>
          <ng-template #elseClose> &times; </ng-template>
        </span>
      </button>
    </div>
    <div class="confirmation-dialog-body" [ngStyle]="{ 'margin-bottom': propertyHistory ? '24px' : '20px' }">
      <ng-content></ng-content>
    </div>
    <div class="confirmation-dialog-footer mr-4 mb-3 ml-auto" *ngIf="!viewonly">
      <button *ngIf="cancelable" type="button" class="_cancel-btn mr-2" (click)="cancel()">{{ secondary_btn_name }}</button>
      <button type="button" class="_outline-btn" (click)="confirm()">{{ primary_btn_name }}</button>
    </div>
  </div>
</ng-container>
